<template>
  <div>

        <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
    <v-toolbar flat color="white">
      <v-toolbar-title>Upazila</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create New</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.english_title" label="Upazila Name"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.bangla_title" label="Bangla Name"></v-text-field>
                </v-flex>
              </v-layout>
              
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-select 
                  v-model="editedItem.district_id" 
                  :items="indexData.districts" 
                  item-text="bangla_title" 
                  item-value="id" 
                  box label="Select District"
                  ></v-select>
                </v-flex>
              </v-layout>
            
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.longitude" label="longitude"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.latitude" label="latitude"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.english_title }}</td>
        <td class="text-xs-center">{{ props.item.bangla_title }}</td>
        <td class="text-xs-center">{{ props.item.district.bangla_title }}</td>
        <td class="text-xs-center">{{ props.item.district.english_title }}</td>
        <td class="text-xs-center">{{ props.item.latitude }}</td>
        <td class="text-xs-center">{{ props.item.longitude }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'upazila',
      headers: [
        { text: 'Upazila Name', align:'center', value: 'ID' },
        { text: 'Upazila Name', align:'center', value: 'english_title' },
        { text: 'Bangla Name', align:'center', value: 'bangla_title' },
        { text: 'Upazila Name', align: 'center', value: 'upazila_id'},
        { text: 'District Name', align: 'center', value: 'district_id'},
        { text: 'latitude', align:'center', sortable: false, value: 'latitude' },
        { text: 'longitude', align:'center', sortable: false, value: 'longitude' },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: {
        english_title: '',
        bangla_title: '',
        district_id: '',
        latitude: '',
        longitude: '',
      },
      defaultItem: {
        english_title: '',
        bangla_title: '',
        latitude: '',
        longitude: '',
        district_id: '',
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Upazila' : 'Edit Upazila'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      division(event) {
        
        let divisionId = event;
        if (divisionId != undefined) {
          let districtsValue = [];
          for (let i = 0; i < this.indexData.datas.length; i++) {
            if (this.indexData.datas[i].division_id == divisionId) {
              districtsValue.push(this.indexData.datas[i]);
            }
          }
          this.editedItem.filterDistricts = districtsValue;
        }
      },
      deleteItem (item) {
        const index = this.indexData.datas.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.datas.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        // console.log([this.editedItem]);
        if (this.editedIndex > -1) {
          // console.log('success');
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>